import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@pulse-web-ui/button';
import { RGSAlert } from '@pulse-web-ui/icons';

import { StyledBox, StyledButtonBox, StyledText } from './score-error.styles';

const CLIENT_LANDING_URL = 'https://pulse.insure/';

interface ErrorPageProps {
  isObjectDataError?: boolean;
  isAgentFlow?: boolean;
}

export const ScoreErrorContent: FC<ErrorPageProps> = ({
  isObjectDataError,
  isAgentFlow,
}) => {
  const { t } = useTranslation();
  const errorText = t('SCORE_ERROR:errors.subscriptionIsNotAvailable');

  const handleClick = () => {
    const globalWindow = window.top as Window;

    globalWindow.location.href = isAgentFlow
      ? window.envUrls.AGENT_URL
      : CLIENT_LANDING_URL;
  };

  const objectErrorText = t(
    'SCORE_ERROR:errors.weCantSubscribeToSelectedAddress'
  );

  //TODO: изменить текст в StyledErrorSubText. Сейчас временно убрали
  return (
    <StyledBox>
      <RGSAlert width={64} />
      <StyledText>{isObjectDataError ? objectErrorText : errorText}</StyledText>
      {/* {isObjectDataError && (
        <StyledErrorSubText>{objectErrorSubText}</StyledErrorSubText>
      )} */}
      <StyledButtonBox isObjectDataError={isObjectDataError}>
        <Button onClick={handleClick} variant="primary">
          {t('COMMON:buttons.startAgain')}
        </Button>
      </StyledButtonBox>
    </StyledBox>
  );
};
